import { render, staticRenderFns } from "./AssignReviewMembersListItem.vue?vue&type=template&id=113bb5ac&scoped=true&"
import script from "./AssignReviewMembersListItem.vue?vue&type=script&lang=js&"
export * from "./AssignReviewMembersListItem.vue?vue&type=script&lang=js&"
import style0 from "./AssignReviewMembersListItem.vue?vue&type=style&index=0&id=113bb5ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113bb5ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
